import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AITranslationService {

  constructor(private http: HttpClient) {}

  /**
   * Translate a single text to a target language.
   */
  translate(text: string, sourceLang: string, targetLang: string) {
    return this.http.post<any>(`${environment.apiUrl}/ai-translation/translate`, {
      text,
      source_lang: sourceLang,
      target_lang: targetLang,
    });
  }

  /**
   * Translate a text to all other supported languages.
   * Returns { translations: { en: '...', de: '...', fr: '...', it: '...' } }
   */
  translateAll(text: string, sourceLang: string) {
    return this.http.post<any>(`${environment.apiUrl}/ai-translation/translate-all`, {
      text,
      source_lang: sourceLang,
    });
  }

  /**
   * Translate a full field_translations object, filling in empty languages.
   * Input: { "description": { "de": "Hallo", "en": "", "fr": "", "it": "" } }
   * Output: same structure with empty values filled.
   */
  translateFields(fieldTranslations: any, sourceLang: string) {
    return this.http.post<any>(`${environment.apiUrl}/ai-translation/translate-fields`, {
      field_translations: fieldTranslations,
      source_lang: sourceLang,
    });
  }
}
